<router-outlet></router-outlet>
<irembogov-toast aria-live="polite" aria-atomic="true"></irembogov-toast>
